import { render, staticRenderFns } from "./TwoColumnLayout.vue?vue&type=template&id=4a1146d3&scoped=true&"
import script from "./TwoColumnLayout.vue?vue&type=script&lang=js&"
export * from "./TwoColumnLayout.vue?vue&type=script&lang=js&"
import style0 from "./TwoColumnLayout.vue?vue&type=style&index=0&id=4a1146d3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1146d3",
  null
  
)

export default component.exports